<section class="p-3">

<lib-dialog-header
  [titulok]="'Prihlásenie na rozvrh' | translate"
  [predmetNazov]="predmet.predmetNazov"
  [predmetSkratka]="predmet.predmetSkratka"
  [predmetRozsah]="predmet.rozsah">
</lib-dialog-header>

<mat-dialog-content class="mat-typography p-1 pe-3 p-sm-3 dialog-scroll">


    <div *ngIf="readOnly" class="alert alert-danger text-center" i18n>Momentálne nie je možné prihlasovať/odhlasovať sa na rozvrh hodín.</div>

    <div *ngIf="!akcie.length">
      <span i18n>Neexistujú rozvrhové akcie, na ktoré by sa dalo prihlásiť.</span>
    </div>

    <app-rozvrhova-akcia *ngFor="let a of akcie" [akcia]="a" [disabled]="readOnly">

    </app-rozvrhova-akcia>

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
    <button *ngIf="!readOnly && akcie.length" mat-stroked-button (click)="ulozit()">
      <span i18n>Uložiť</span>
    </button>
  </mat-dialog-actions>

</section>
